export default {
  name: 'Maps',
  props: {
    circleDot: {
      type: Object,
      default() {
        return {
          latitude: 40.161855,
          longitude: 116.665191
        }
      }
    }
  },
  data() {
    return {
      MAps: null, // 地图实例
      geolocation: null, // 定位实例
      circle: null, // 画圆实例
      site: '' // 地址
    }
  },
  mounted() {
    this.initMaps()
  },
  methods: {
    /**
     * 初始化地图
     */
    initMaps() {
      var marker
      let that = this
      //初始化地图
      // eslint-disable-next-line no-undef
      var map = new AMap.Map('MAps', {
        center: [that.circleDot.longitude, that.circleDot.latitude],
        resizeEnable: true

        //zoom:15
      })
      //输入提示
      var autoOptions = {
        input: 'tipinput'
      }

      // eslint-disable-next-line no-undef
      var auto = new AMap.Autocomplete(autoOptions)
      //构造地点查询类

      // eslint-disable-next-line no-undef
      var placeSearch = new AMap.PlaceSearch({
        map: map
      })

      //注册监听，当选中某条记录时会触发
      // eslint-disable-next-line no-undef
      AMap.event.addListener(auto, 'select', select)

      //关键字查询查询
      function select(e) {
        placeSearch.setCity(e.poi.adcode)
        placeSearch.search(e.poi.name)

      }

      if (that.circleDot.longitude && that.circleDot.latitude) {
        if (marker) {
          marker.setMap(null)
          marker = null
        }
        // eslint-disable-next-line no-undef
        marker = new AMap.Marker({
          // eslint-disable-next-line no-undef
          icon: new AMap.Icon({
            image:
              '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
            // eslint-disable-next-line no-undef
            size: new AMap.Size(50, 50), //图标大小
            // eslint-disable-next-line no-undef
            imageSize: new AMap.Size(26, 30)
          }),
          position: [that.circleDot.longitude, that.circleDot.latitude],
          // eslint-disable-next-line no-undef
          offset: new AMap.Pixel(-10, -18)
        })
        marker.setMap(map)
      }
      //绑定点击事件
      map.on('click', showInfoClick)

      function showInfoClick(e) {
        that.circleDot.longitude = e.lnglat.getLng()
        that.circleDot.latitude = e.lnglat.getLat()
        var coordinateB = e.lnglat.getLng() + ',' + e.lnglat.getLat()
        if (marker) {
          marker.setMap(null)
          marker = null
        }
        // eslint-disable-next-line no-undef
        marker = new AMap.Marker({
          // eslint-disable-next-line no-undef
          icon: new AMap.Icon({
            image:
              '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
            // eslint-disable-next-line no-undef
            size: new AMap.Size(52, 52), //图标大小
            // eslint-disable-next-line no-undef
            imageSize: new AMap.Size(26, 26)
          }),
          position: [that.circleDot.longitude, that.circleDot.latitude],
          // eslint-disable-next-line no-undef
          offset: new AMap.Pixel(-13, -20)
        })
        that.$emit('submitcircleDotircleDot', that.circleDot)

        marker.setMap(map)
        regeoCode(coordinateB) // 抓取地图名称组件定位的
      }

      // eslint-disable-next-line no-undef
      var geocoder = new AMap.Geocoder({
        // city: "010", //城市设为北京，默认：“全国”
        // radius: 1000 //范围，默认：500
      })

      function regeoCode(lnglat) {
        geocoder.getAddress(lnglat, function (status, result) {
          if (status === 'complete' && result.regeocode) {
            var address = result.regeocode.formattedAddress

            that.circleDot.address = address
            that.$emit('submitcircleDotircleDot', that.circleDot)
          } else {
            this.$message.error('根据经纬度查询地址失败')
          }
        })
      }
    }
  }
}
